var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "34.636",
        height: "34.627",
        viewBox: "-79.307 -0.241 34.636 34.627",
      },
    },
    [
      _c("g", { attrs: { "data-name": "Group 195" } }, [
        _c("path", {
          attrs: {
            d: "M-76.045 9.546c.297.15 1.14.595 2.06-.438.368-.517.736-1.034 1.174-1.543.517-.587.44-1.543-.148-2.06-.588-.516-1.543-.438-2.06.15a18.516 18.516 0 0 0-1.472 1.91c-.431.658-.212 1.536.446 1.981Z",
            fill: _vm.color || "#333",
            "fill-rule": "evenodd",
            "data-name": "Path 753",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M-61.686 2.625c1.402 0 2.796.22 4.126.665.892.262 1.543-.297 1.84-.884.22-.807-.22-1.62-.955-1.84-1.62-.517-3.241-.807-4.933-.807-.807 0-1.472.587-1.472 1.401 0 .814.588 1.465 1.394 1.465Z",
            fill: _vm.color || "#333",
            "fill-rule": "evenodd",
            "data-name": "Path 754",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M-48.579 11.606c.517 1.252.807 2.576.955 3.9 0 0 .085 1.641 1.621 1.4 1.522-.198 1.323-1.69 1.323-1.69-.148-1.622-.587-3.242-1.174-4.714-.368-.736-1.175-1.104-1.911-.807-.743.368-1.111 1.175-.814 1.91Z",
            fill: _vm.color || "#333",
            "fill-rule": "evenodd",
            "data-name": "Path 755",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M-53.88 5.13a14.382 14.382 0 0 1 3.093 2.874c.658.82 1.77.48 1.989.22.587-.518.736-1.473.219-2.06a18.305 18.305 0 0 0-3.68-3.39c-.665-.439-1.543-.297-1.989.368-.446.665-.297 1.543.368 1.988Z",
            fill: _vm.color || "#333",
            "fill-rule": "evenodd",
            "data-name": "Path 756",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M-69.782 4.904a14.796 14.796 0 0 1 3.829-1.691c.807-.22 1.253-1.034 1.033-1.77C-65.14.637-65.953.191-66.689.41A16.741 16.741 0 0 0-71.254 2.4c-.665.438-.884 1.323-.438 1.988.29.446.912.885 1.91.517Z",
            fill: _vm.color || "#333",
            "fill-rule": "evenodd",
            "data-name": "Path 757",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M-46.152 18.747c-.806-.22-1.542.297-1.691 1.104-.149.665-.602 2.215-.609 2.363-1.946 5.06-6.617 8.62-11.981 9.193-5.28.552-10.417-1.833-13.397-6.121l2.725.601c.736.149 1.543-.297 1.691-1.104.149-.736-.297-1.543-1.104-1.691l-5.74-1.253c-.367-.07-1.514 0-1.768 1.104l-1.253 5.817c-.149.736.297 1.543 1.104 1.692.899.092 1.543-.439 1.77-1.175l.438-1.996c3.277 4.438 9.193 7.721 15.831 7.007 6.695-.722 12.37-5.23 14.579-11.557.07-.184.403-1.727.516-2.286.22-.814-.297-1.55-1.11-1.698Z",
            fill: _vm.color || "#333",
            "fill-rule": "evenodd",
            "data-name": "Path 758",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M-67.659 18.527h6.787c.807 0 1.401-.665 1.472-1.472V6.992a1.48 1.48 0 0 0-1.472-1.472 1.48 1.48 0 0 0-1.472 1.472v8.591h-5.315a1.48 1.48 0 0 0-1.472 1.472c0 .807.659 1.472 1.472 1.472Z",
            fill: _vm.color || "#333",
            "fill-rule": "evenodd",
            "data-name": "Path 759",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }